var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-1 iv-paragraph"},[_vm._v("質問数")]),_c('p',{staticClass:"mb-4 mt-0 iv-paragraph"},[_vm._v(_vm._s(_vm.num)+" 問 ( 所要時間：約 "+_vm._s(_vm.time)+" 分 )")])])}
var staticRenderFns = []

export { render, staticRenderFns }